import { useState } from 'react';
import PropTypes from 'prop-types';
import { format, formatDistanceStrict } from 'date-fns';
import useInterval from './useInterval';

const useRelativeTime = timestamp => {
  const calculateRelativeTime = () => {
    return timestamp ? formatDistanceStrict(new Date(timestamp), Date.now(), { addSuffix: true }) : null;
  };
  const [relativeTime, setRelativeTime] = useState(calculateRelativeTime());

  useInterval(() => {
    setRelativeTime(calculateRelativeTime());
  }, 6000);

  const formattedDatetime = format(new Date(timestamp), 'MMM dd, yyyy h:mm a');
  return [relativeTime, formattedDatetime];
};

useRelativeTime.propTypes = {
  timestamp: PropTypes.string.isRequired
};

export default useRelativeTime;
